import React,{useEffect,useState} from 'react';
import ReactLoading from 'react-loading';
import Header from '../../components/common/Header';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';
import {useNavigate,useLocation,Link} from 'react-router-dom';
import {getStudentTransactions,getSelectedDetail, getStudentExamResultDetail, getStudentResultNumber} from '../../actions/StudentAction'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFilePdf, faCertificate} from '@fortawesome/free-solid-svg-icons';
import ResultOverviewSection from '../../components/TallentexResult/ResultOverviewSection';
import RelativeComparision from '../../components/TallentexResult/RelativeComparision';
import SubjectScore from '../../components/TallentexResult/SubjectScore';
import YourRank from '../../components/TallentexResult/YourRank';
import QuestionStatics from '../../components/TallentexResult/QuestionStatics';
import CompetiveSuccessIndex from '../../components/TallentexResult/CompetiveSuccessIndex';
import SubjectTopicAnalysis from '../../components/TallentexResult/SubjectTopicAnalysis';
import DifficultyLevelTable from '../../components/TallentexResult/DifficultyLevelTable';
import DiffcultyLevelChart from '../../components/TallentexResult/DifficultyLevelChart';
import AttemptedDifficultyLevelChart from '../../components/TallentexResult/AttemptedDifficultyLevelChart';
import { getStudentFee } from '../../actions/StudentAction';
import certificateImg from '../../assets/images/certificate.png'



const Result = (props) => {

  const navigate = useNavigate()
  const location=useLocation();
  const[transactions,setTransaction]=useState([])
  const[detail,setDetail]=useState(undefined)
    const [resultDetail,setResultDetail] = useState()
    const [studentResult,setStudentResult] = useState();
    const [loading,setLoading] = useState(true)
    const [feeDetail,setFeeDetail] = useState({});

  useEffect(() => {
    sessionStorage.getItem('userDetail') ?  navigate('/result') : navigate('/login');
   
    if(location&& location.state!==null){
      const {detail}=location.state
      const userId=detail.id

      getSelectedDetail(userId).then((res) => {
        setDetail(res.data);
    });
 
    getStudentExamResultDetail(detail !== undefined && detail.form_num).then((res) => {
        // console.log('exam detail..',res)
        setResultDetail(res.data)
        setLoading(false)
    })

    getStudentFee(detail!==undefined&& detail.id, 1).then(res => {
        setFeeDetail(res.data)
    });
  
  }




},[location.state]);

const studentSubject = resultDetail !== undefined && resultDetail.subject
const subjectTopics = resultDetail !== undefined && resultDetail.topic
const resultSummary = resultDetail !== undefined && resultDetail.summary


let subjectItem = []
for (let subject in  studentSubject) {
    subjectItem[subject]=studentSubject[subject];
}



  return (
    <>
     {loading ? <div className="screenLoader"><ReactLoading type={"bars"} width={80}  color={"#20367f"}/></div>:
     <>
    <Header detail={detail}/>
       <section className="pt-5 pb-5 content-section">
          <div className="container">
            <PageBreadcrumbs profileDetailLink={detail} pagename="Result" colFull/>
            <div className="row mt-2 mb-2">
                <div className="col-lg-8">
                    <h3 className='fw-bold mt-0 '>Welocme, {detail !==undefined && detail.name}</h3>
                    <p className='text-muted'>TALLENTEX Overseas 2023 Performance Analysis/CSI</p>
                </div>
            </div>
            <div className='row'>
            <div className='col-lg-12 result_overviewTab'>
                <div className='card p-4'>
                    <div className='card-header bg-transparent p-0 border-0 pb-2 d-flex flex-wrap align-items-center '>
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="pill-overview-tab" data-bs-toggle="pill" data-bs-target="#pill-overview" type="button" role="tab" aria-controls="pill-overview" aria-selected="true">Result Overview</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pill-topic-tab" data-bs-toggle="pill" data-bs-target="#pill-topic" type="button" role="tab" aria-controls="pill-topic" aria-selected="false">Topic Analysis</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pill-difficulty-tab" data-bs-toggle="pill" data-bs-target="#pill-difficulty" type="button" role="tab" aria-controls="pill-difficulty" aria-selected="false">Difficulty Level</button>
                        </li>
                    </ul>
                    <a href={detail !==undefined && detail.final_pdf}  target="_blank" className='ms-auto pdfLink_view d-inline-block' >
                     <img src={certificateImg} style={{width:'25px', marginRight:'8px', marginBottom:'-3px'}}/>
                     View Participation Certificate</a>

                    <Link to="/pdf-download" className='pdfLink_view' state={{detail:detail}}><FontAwesomeIcon color='brown' icon={faFilePdf}/>&nbsp; Download Result PDF</Link>
                    </div>
                    <div class="tab-content p-0" id="pills-tabContent">
                        {/* Result Overview */}
                        <div class="tab-pane fade show active" id="pill-overview" role="tabpanel" aria-labelledby="pill-overview-tab">
                        <div className='row'>
                            <div className='col-lg-8'>
                                <ResultOverviewSection resultDetail={resultDetail !== undefined && resultDetail}/>
                                {/* {resultDetail !==undefined && resultSummary.cash_prize !== null && 
                                        <div className='cash_prizeWinnerWrap'>
                                        <h5 className='rank_title'>Congratulations you have won {feeDetail!==undefined&& feeDetail.scholarship_percentage}% scholarship and cash reward of Rs {resultDetail !==undefined && resultSummary.cash_prize} amount (if any) based on your TALLENTEX Overseas 2023 Performance. </h5>
                                        </div>
                                } */}
                                
                  
                                <RelativeComparision  resultDetail={resultDetail !== undefined && resultDetail}/>
                                <SubjectScore resultDetail={resultDetail !== undefined && resultDetail} showTitle={true}/>
                            </div>
                            {/* col-lg-8 */}
                            <div className='col-lg-4'>
                                <YourRank detail={detail !==undefined && detail}  resultDetail={resultDetail !== undefined && resultDetail}  title={true}/>
                                <QuestionStatics studentResult={resultDetail !==undefined && resultDetail}/>
                                <CompetiveSuccessIndex detail={detail !== undefined && detail} resultDetail={resultDetail !== undefined && resultDetail}/>
                            </div>
                        </div>
                        {/* row */}
                        </div>
                        {/* Topic Analysis */}
                        <div class="tab-pane fade" id="pill-topic" role="tabpanel" aria-labelledby="pill-topic-tab">
                            {
                                subjectItem !== undefined && subjectItem.map((item,key) => (
                                    <>
                                    <SubjectTopicAnalysis subjectIndex={item.fieldvalue} subjectName={item.fieldvalue} studentResult={resultDetail !==undefined && resultDetail}/>
                                    </>
                                ))
                            }
                         
                        {/* <SubjectTopicAnalysis/> */}
                        </div>
                        {/* Difficulty Level */}
                        <div class="tab-pane fade" id="pill-difficulty" role="tabpanel" aria-labelledby="pill-difficulty-tab">
                            <div className='card p-4'>
                                <DifficultyLevelTable  studentResult={resultDetail !==undefined && resultDetail}/>

                                <div className='container'>
                                    <div className='row'>
                                        <div className='col-lg-4 mt-5'>
                                            <div className='widget_title d-flex align-items-center justify-content-between'>
                                                <h3>Question Difficulty Levels</h3>
                                            </div>
                                            <DiffcultyLevelChart studentResult={resultDetail !==undefined && resultDetail}/>
                                        </div>
                                        <div className='col-lg-2'></div>
                                        <div className='col-lg-4 mt-5'>
                                            <div className='widget_title d-flex align-items-center justify-content-between'>
                                                <h3>Attempted Questions</h3>
                                            </div>
                                            <AttemptedDifficultyLevelChart studentResult={resultDetail !==undefined && resultDetail}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            

        </div>

        </section>
        </>
}
    </>
  )
}

export default Result
